/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  MenuItem,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Close";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/PatientManagementHelper/PatientManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import {
  getDateFormatInSpanish,
  mergeListById,
} from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import HeartRateHeader from "./Header/HeartRateHeader"; // This will be created
import VitalCommonheader from "../Common/Header/VitalCommonheader";
import SaveHeartRatePopup from "./Popup/SaveHeartRatePopup";

const HeartRateBody = () => {
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [heartRateList, setHeartRateList] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedHeartRateIds, setSelectedHeartRateIds] = useState([]);
  const [selectedHeartRateId, setSelectedHeartRateId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //get all heart rate
  const getAllHeartRate = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_HEART_RATE + `?token=${token}`;

      const response = await getData(requestUrl);

      setIsLoading(false);

      if (response.status) {
        const { listrecords } = response.data;
        setHeartRateList(listrecords);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  //update heart rate
  const updateBulkHeartRateHandler = async () => {
    if (selectedHeartRateIds.length > 0) {
      try {
        const heartRateListToBeUpdate = heartRateList.filter((item) =>
          selectedHeartRateIds.includes(item._id)
        );

        let heartRateData = {
          heartratelist: heartRateListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_HEART_RATE + `?token=${token}`;

        const response = await putData(requestURL, heartRateData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedHeartRateIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {}
    } else {
      setAlertMessage("Please select at least one heart rate");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //delete heart rate
  const deleteBulkHeartRateHandler = async () => {
    if (selectedHeartRateIds.length > 0) {
      try {
        const heartRateListToBeDelete = heartRateList.filter((item) =>
          selectedHeartRateIds.includes(item._id)
        );

        let heartRateData = {
          heartratelist: heartRateListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_HEART_RATE + `?token=${token}`;

        const response = await putData(requestURL, heartRateData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setHeartRateList((prevList) =>
              prevList.filter(
                (item) => !selectedHeartRateIds.includes(item._id)
              )
            );

            setSelectedHeartRateIds([]);
            setRowSelection({});
          }, 1500);
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one heart rate");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const afterActionClose = (data = []) => {
    setHeartRateList((prevList) => mergeListById(prevList, data));
  };

  useEffect(() => {
    getAllHeartRate();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasSaveHeartRate"
            aria-controls="offcanvasSaveHeartRate"
            onClick={() => {
              setSelectedHeartRateId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Heart Rate (bpm)",
        accessorKey: "bpm",
        size: 200,
      },
      {
        header: "Date",
        accessorKey: "date",
        size: 200,
        Cell: ({ cell }) => getDateFormatInSpanish(cell.getValue()),
      },
      {
        header: "Assigned To",
        accessorKey: "username",
        size: 300,
        Cell: ({ row }) => (
          <div
            className={
              row.original.username === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.userimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.userimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.username}</span>
            </p>
          </div>
        ),
      },
    ],
    []
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedHeartRateIds(selectedIdsArray);
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_APPOINTMENT_MANAGEMENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper crm-conversation-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Vitals")}
          />
          <div className="container-fluid px-lg-5">
            <HeartRateHeader
              selectedItemIds={selectedHeartRateIds}
              updateBulkHandler={updateBulkHeartRateHandler}
              reloadList={getAllHeartRate}
            />

            <VitalCommonheader activeOption="heartrate" />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={heartRateList}
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox in each row
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* modal and popup section  */}

          <SaveHeartRatePopup
            heartRateId={selectedHeartRateId}
            setHeartRateId={setSelectedHeartRateId}
            afterActionClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <AssignUserModal
            moduleName="heartrate"
            afterModalClose={afterActionClose}
            selectedIds={selectedHeartRateIds}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedHeartRateIds([]);
            }}
          />

          <DeleteWarningModal
            onDelete={deleteBulkHeartRateHandler}
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedHeartRateIds([]);
            }}
            moduleName={t("heart rate")}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default HeartRateBody;
